// CPU-side geometry release for the static world (M10 heap budget).
//
// Babylon keeps every position/normal/uv/index array alive in Buffer._data
// after the upload, so it can re-pick, re-bake or survive a context loss. The
// map10k world is generated once and never read back, and a CDP heap snapshot
// at primorsk-center (2026-08-16) measured what that costs:
//
//     array:(object elements)        268.7 MB  <- plain-Array position/normal/uv
//     native:JSArrayBufferData       226.4 MB  <- of which 145.6 MB is Buffer._data
//     number:heap number              37.8 MB
//     ------------------------------------------
//     total live after a forced GC   603.4 MB   (usedJSHeapSize 1280 MB)
//
// i.e. roughly two thirds of the live heap was a second copy of geometry that
// already lives in GPU buffers — and it grows as you walk, because terrain
// tiles are cached by key and never evicted (65 tiles at the first bench stop,
// 164 at the fourth).
//
// releaseCPUGeometry() drops that copy. It is ONLY correct for a mesh that
//   * is not pickable — picking walks the CPU index/position arrays;
//   * is never updated — no updateVerticesData / bakeCurrentTransformIntoVertices
//     / createNormals / refreshBoundingInfo after this point;
//   * is done with getVerticesData().
// Bounding info is already computed by applyToMesh and survives, and
// Geometry.clearCachedData() stashes _totalIndices first, so getTotalIndices()
// — the number ui/perf.js and tools/mapbench.mjs count — keeps working.
export function releaseCPUGeometry(mesh) {
  const g = mesh && mesh.geometry;
  if (!g || g.__ashCpuReleased) return mesh;
  g.__ashCpuReleased = true;
  g.clearCachedData();
  return mesh;
}
